import { ThirdPartyEvaluationFormItemRecordColumn } from './thirdparty-evaluation-form-item-record-columns';

export class ThirdPartyEvaluationFormItemRecordColumnPossibleAnswer {
    id: number | ThirdPartyEvaluationFormItemRecordColumn = 0;
    description: string = '';

    constructor() {
    }
}
